const URL_REGEX = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
const TRAILING_PUNCTUATION_REGEX = /[.,!?;:)\]]+$/;

export const linkifyText = (text) => {
  if (!text) return [];

  const segments = [];
  const regex = new RegExp(URL_REGEX);
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    const matchStart = match.index;
    let url = match[0];
    let trailing = "";

    const trailingMatch = url.match(TRAILING_PUNCTUATION_REGEX);
    if (trailingMatch) {
      trailing = trailingMatch[0];
      url = url.slice(0, url.length - trailing.length);
    }

    if (matchStart > lastIndex) {
      segments.push({ type: "text", value: text.slice(lastIndex, matchStart) });
    }

    const href = url.startsWith("http") ? url : `https://${url}`;
    segments.push({ type: "link", value: url, href });

    if (trailing) {
      segments.push({ type: "text", value: trailing });
    }

    lastIndex = matchStart + match[0].length;
  }

  if (lastIndex < text.length) {
    segments.push({ type: "text", value: text.slice(lastIndex) });
  }

  return segments;
};

export default linkifyText;
